import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Modal, Image } from 'react-bootstrap';
import { productsData, specialOffers, createProductWhatsappUrl } from '../data/productsData';
import { createProductMessengerUrl } from '../data/orderFormData';
import './ProductsPage.css';

const ProductsPage = ({ onNavigate }) => {
  const [selectedColors, setSelectedColors] = useState({});
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [countdown, setCountdown] = useState({
    days: 3,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  // تحديث العد التنازلي
  React.useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        } else if (prev.hours > 0) {
          return { ...prev, hours: prev.hours - 1, minutes: 59, seconds: 59 };
        } else if (prev.days > 0) {
          return { ...prev, days: prev.days - 1, hours: 23, minutes: 59, seconds: 59 };
        }
        return prev;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleColorSelect = (productId, colorName) => {
    setSelectedColors(prev => ({
      ...prev,
      [productId]: colorName
    }));
  };

  const getProductImage = (product) => {
    const selectedColorName = selectedColors[product.id];
    if (selectedColorName) {
      const colorOption = product.colors.find(c => c.name === selectedColorName);
      if (colorOption && colorOption.image) {
        return colorOption.image;
      }
    }
    return product.image;
  };

  const openImageModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    setShowImageModal(true);
  };

  const handleOrderNow = (product) => {
    const selectedColor = selectedColors[product.id] || product.colors[0].name;
    const whatsappUrl = createProductWhatsappUrl(product, selectedColor);
    window.open(whatsappUrl, '_blank');
  };

  const handleSpecialOfferClick = () => {
    if (onNavigate) {
      onNavigate('order');
    } else {
      // Fallback if onNavigate is not provided (e.g. scroll to order form if on same page)
      const orderSection = document.getElementById('order-form');
      if (orderSection) {
        orderSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <div className="products-page" dir="rtl">
      <Container fluid className="products-container">
        {/* Header */}
        <div className="products-header">

        </div>

        {/* Main Products Section */}
        <div className="products-main-section">
          <h2 className="section-title">الملابس النسائية</h2>

          <Row className="products-grid">
            {productsData.map((product) => {
              const currentImage = getProductImage(product);
              return (
                <Col lg={4} md={6} sm={12} key={product.id} className="product-col">
                  <Card className="product-card">
                    <div className="product-image-container" onClick={() => openImageModal(currentImage)}>
                      <Image src={currentImage} alt={`${product.title} - moda-lady`} className="product-image" />
                    </div>

                    <Card.Body className="product-body">
                      <h3 className="product-title">{product.title}</h3>
                      <div className="product-price">{product.price}</div>

                      {/* Available Colors */}
                      <div className="colors-section">
                        <h4 className="colors-label">الألوان المتوفرة:</h4>
                        <div className="color-options">
                          {product.colors.map((color, index) => (
                            <button
                              key={index}
                              className={`color-option ${selectedColors[product.id] === color.name ? 'selected' : ''}`}
                              style={{ backgroundColor: color.hex }}
                              onClick={() => handleColorSelect(product.id, color.name)}
                              title={color.name}
                            />
                          ))}
                        </div>
                      </div>

                      {/* Technical Features */}
                      <div className="features-section">
                        <h4 className="features-label">الميزات:</h4>
                        <ul className="features-list">
                          {product.features.map((feature, index) => (
                            <li key={index} className="feature-item">
                              {feature}
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Order Button */}
                      <div className="d-flex flex-column gap-2">
                        <Button
                          className="order-button py-2"
                          onClick={() => handleOrderNow(product)}
                        >
                          اطلب عبر واتساب
                        </Button>
                        <Button
                          as="a"
                          href={createProductMessengerUrl(product, selectedColors[product.id] || product.colors[0].name)}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ backgroundColor: '#2F3E46', border: 'none', borderRadius: '8px', color: '#fff', padding: '8px 12px' }}
                          aria-label="اطلب عبر ماسنجر"
                          className="order-button py-2"
                        >
                          <i className="bi bi-messenger me-2"></i>
                          اطلب عبر ماسنجر
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </div>

        {/* Special Offers Section */}
        <div className="offers-section" id="offers">
          <h2 className="offers-title">عروض خاصة</h2>

          <Row className="offers-grid justify-content-center">
            {specialOffers.map((offer) => (
              <Col md={offer.images ? 10 : 5} key={offer.id} className="mb-4">
                <div className={`offer-card ${offer.images ? 'offer-card-large' : ''}`}>
                  {offer.images ? (
                    <div className="offer-images-grid">
                      {offer.images.map((img, idx) => (
                        <Image key={idx} src={img} alt={`عرض ${idx + 1}`} className="offer-grid-image" onClick={() => openImageModal(img)} />
                      ))}
                    </div>
                  ) : (
                    offer.image && <Image src={offer.image} alt="عرض خاص" className="offer-image mb-3" />
                  )}

                  <div className="offer-content">
                    <h3 className="offer-card-title">{offer.title}</h3>
                    <div className="offer-text">
                      {offer.text}
                    </div>
                    {offer.price && <div className="offer-price">{offer.price}</div>}
                    <Button
                      className="offer-cta-button mt-3"
                      onClick={handleSpecialOfferClick}
                    >
                      اطلبي العرض الآن
                    </Button>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* Countdown Timer */}
          <div className="countdown-section mt-5">
            <p className="countdown-label">العرض ينتهي في:</p>
            <div className="countdown-timer">
              <div className="countdown-item">
                <div className="countdown-number">{countdown.days.toString().padStart(2, '0')}</div>
                <div className="countdown-label-small">أيام</div>
              </div>
              <div className="countdown-separator">:</div>
              <div className="countdown-item">
                <div className="countdown-number">{countdown.hours.toString().padStart(2, '0')}</div>
                <div className="countdown-label-small">ساعات</div>
              </div>
              <div className="countdown-separator">:</div>
              <div className="countdown-item">
                <div className="countdown-number">{countdown.minutes.toString().padStart(2, '0')}</div>
                <div className="countdown-label-small">دقائق</div>
              </div>
              <div className="countdown-separator">:</div>
              <div className="countdown-item">
                <div className="countdown-number">{countdown.seconds.toString().padStart(2, '0')}</div>
                <div className="countdown-label-small">ثواني</div>
              </div>
            </div>
          </div>
        </div>

      </Container>

      {/* Image Modal */}
      <Modal show={showImageModal} onHide={() => setShowImageModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>صورة الملابس</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <Image src={selectedImage} fluid alt="صورة مكبرة" />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ProductsPage;
